import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";
import { CustomerNotificationsWithDialogProps, CustomerNotificationsWithDialogFTNodeOptions } from "./typings";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { CustomerNotificationsWithDialogWrapper } from "components/shared/CustomerNotifications/CustomerNotificationsWithDialogWrapper";

export const CustomerNotificationsWithDialog = withStores("flexModuleModelStore")(
  observer((props: CustomerNotificationsWithDialogProps) => {
    // hooks before conditionals
    const { flexTemplateNode, flexModuleModelStore } = props;

    const { id } = flexTemplateNode;
    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(id)
    ) as CustomerNotificationsWithDialogFTNodeOptions;

    if (!options.location) {
      return null;
    }

    return (
      <div id={id}>
        <Viewport>
          <ViewSmall>
            <div data-testid="customer-notification">
              <CustomerNotificationsWithDialogWrapper
                location={options.location}
                className="customerNotificationSquare all-x-padding-six"
              />
            </div>
          </ViewSmall>
          <ViewMedium>
            <div data-testid="customer-notification">
              <CustomerNotificationsWithDialogWrapper
                location={options.location}
                className="customerNotificationSquare all-t-padding-six all-b-padding-three"
              />
            </div>
          </ViewMedium>
        </Viewport>
      </div>
    );
  })
);

export default CustomerNotificationsWithDialog;
